import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RolesGroupPageComponent } from './roles-group-page.component';

const routes: Routes = [
  { path: 'role-group', component: RolesGroupPageComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RolesGroupPageRoutingModule {}
